import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Flag } from 'lucide-react'

import NormalTopBar from '@/components/common/bar/NormalTopBar'
import CardOne from '@/components/common/card/CardOne'
import { useMissionListQuery } from '@/hooks/queries/mission'

const MissionAllPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [isStored, setIsStored] = useState(location.state?.isStoreMenu)

  const { data: noneStoredMissionList } = useMissionListQuery({ is_stored: false })
  const { data: storedMissionList } = useMissionListQuery({ is_stored: true })

  return (
    <div className='min-h-screen flex flex-col'>
      <NormalTopBar
        prevButton
        title='전체 미션'
        onPrevButtonClick={() => navigate(-1)}
        textClassName='text-xl text-text-header font-semibold'
        boxClassName='sticky top-0 z-10 bg-gradient-to-r from-amber-400 to-yellow-300'
      />
      <div className='h-full p-3 overflow-y-auto flex flex-col gap-3 pb-23'>
        <CardOne className='rounded-2xl px-3 py-5'>
          {/* 탭 헤더 */}
          <div className='flex border-b border-amber-200 mb-4'>
            <button
              className={`flex-1 py-3 text-center font-medium transition-colors border-b-2 ${
                !isStored ? 'text-amber-600 border-amber-500 font-bold' : 'text-gray-500'
              }`}
              onClick={() => setIsStored(false)}
            >
              진행중 ({noneStoredMissionList?.data.total_count})
            </button>
            <button
              className={`flex-1 py-3 text-center font-medium transition-colors border-b-2 ${
                !isStored ? 'text-gray-500' : 'text-amber-600 border-amber-500 font-bold'
              }`}
              onClick={() => setIsStored(true)}
            >
              보관됨 ({storedMissionList?.data.total_count})
            </button>
          </div>

          {/* 미션 리스트 */}
          <div>
            {isStored ? (
              storedMissionList?.data.total_count === 0 ? (
                <div className='text-center py-8 text-gray-500'>
                  <p>'보관된 미션이 없습니다.'</p>
                </div>
              ) : (
                storedMissionList?.data.missions.map(mission => (
                  <div key={mission.mission_id} className='border-b border-amber-100 last:border-b-0'>
                    {/* 메인 미션 내용 */}
                    <div
                      className='flex items-center justify-between p-3 cursor-pointer hover:bg-amber-50 transition-colors'
                      onClick={() => navigate(`/mission/detail/${mission.mission_id}`)}
                    >
                      <div className='flex items-center space-x-3'>
                        <Flag
                          className={`w-5 h-5 ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'text-gray-400' : 'text-amber-500'}`}
                        />
                        <span
                          className={`font-medium text-sm ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'line-through text-gray-400' : 'text-gray-700'}`}
                        >
                          {mission.name}
                        </span>
                      </div>
                      <span
                        className={`text-sm ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'text-gray-400' : 'text-gray-600'}`}
                      >
                        {mission.planned_days === 0
                          ? `${mission.completed_days} 일`
                          : `${mission.completed_days}/${mission.planned_days} 일`}
                      </span>
                    </div>
                  </div>
                ))
              )
            ) : noneStoredMissionList?.data.missions.length === 0 ? (
              <div className='text-center py-8 text-gray-500'>
                <p>'진행중인 미션이 없습니다.'</p>
              </div>
            ) : (
              noneStoredMissionList?.data.missions.map(mission => (
                <div key={mission.mission_id} className='border-b border-amber-100 last:border-b-0'>
                  {/* 메인 미션 내용 */}
                  <div
                    className='flex items-center justify-between p-3 cursor-pointer hover:bg-amber-50 transition-colors'
                    onClick={() => navigate(`/mission/detail/${mission.mission_id}`)}
                  >
                    <div className='flex items-center space-x-3'>
                      <Flag
                        className={`w-5 h-5 ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'text-gray-400' : 'text-amber-500'}`}
                      />
                      <span
                        className={`font-medium text-sm ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'line-through text-gray-400' : 'text-gray-700'}`}
                      >
                        {mission.name}
                      </span>
                    </div>
                    <span
                      className={`text-sm ${mission.planned_days > 0 && mission.completed_days === mission.planned_days ? 'text-gray-400' : 'text-gray-600'}`}
                    >
                      {mission.planned_days === 0
                        ? `${mission.completed_days} 일`
                        : `${mission.completed_days}/${mission.planned_days} 일`}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </CardOne>
      </div>
    </div>
  )
}

export default MissionAllPage
